export const i18nConfig = {
	locales: ["en", "fr", "es"],
	defaultLocale: "en",
};
